var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomerNotifications = function SvgCustomerNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M29.477 39.725a2 2 0 0 1 1.092-.325H44V21H20v18.4h1a2 2 0 0 1 2 2v2.55l6.477-4.225zM21 43.951V41.4h-1a2 2 0 0 1-2-2V21a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v18.4a2 2 0 0 1-2 2H30.57l-6.477 4.226A2 2 0 0 1 21 43.95zM26.5 32a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm12 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm-6 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
  })));
};
export default SvgCustomerNotifications;